/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_TitleInputs */

const en_landing_cta_title = /** @type {(inputs: Landing_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to convert research into revenue in seconds?`)
};

/**
* | output |
* | --- |
* | "Ready to convert research into revenue in seconds?" |
*
* @param {Landing_Cta_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_title = /** @type {((inputs?: Landing_Cta_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_cta_title(inputs)
});